module.exports = __webpack_public_path__ + "assets/dae886392cd88463a91a0155787ff3f1.mp3";